<!-- EdjecFeedbackContent.vue -->
<template>
  <section
    class="flex flex-col items-center justify-center w-full h-[90vh] px-4 bg-transparent overflow-auto"
  >
    <!-- Profile Section -->
    <div class="profile-section flex flex-col items-center text-center">
      <img
        src="@/assets/img/edjec.jpg"
        alt="RAQUEL J. EDJEC"
        class="w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 rounded-full border-4 border-gray-300 mb-4 object-cover"
      />
      <h1 class="text-lg sm:text-xl md:text-2xl font-bold text-white">
        RAQUEL J. EDJEC
      </h1>
      <h2 class="text-sm sm:text-base md:text-lg text-white mb-5">
        Administrative Officer V
      </h2>
    </div>

    <!-- Text + Image Section -->
    <div
      class="flex flex-col-reverse xl:flex-row items-center xl:items-stretch justify-center gap-6 xl:gap-10 mt-6 md:mt-8 w-full max-w-6xl"
    >
      <!-- Text Section -->
      <div class="flex-1 bg-transparent flex items-start justify-center">
        <div class="space-y-4">
          <p
            class="text-white text-justify text-[15px] sm:text-[16px] md:text-[17px] font-light leading-relaxed"
          >
            With the implementation of the Human Resource Information System
            (HRIS), DNSC has significantly improved efficiency and convenience,
            particularly in the Human Resource Management Office, as well as
            among the DNSC employees themselves.
          </p>
          <p
            class="text-white text-justify text-[15px] sm:text-[16px] md:text-[17px] font-light leading-relaxed"
          >
            As a Human Resource Management Officer, the system really helps me
            in a lot of ways — it allows for faster, more efficient transactions
            and processing of resources. It helps generate reports on personnel
            information, leave status, trainings, and monitoring of travels, as
            well as the daily time record of employees. The system has reduced
            manual workload and improved data accuracy and security through a
            centralized, secure database for all employee information.
          </p>
        </div>
      </div>

      <!-- Image Section -->
      <div
        class="flex-1 flex flex-col justify-center items-center space-y-4 xl:space-y-2"
      >
        <img
          src="@/assets/img/edjec-1.jpg"
          alt="HRIS Image 1"
          class="w-full md:w-[500px] md:h-[350px] lg:h-[200px] h-full rounded-2xl border-2 border-gray-300 object-cover shadow-lg"
        />
        <img
          src="@/assets/img/edjec-2.jpg"
          alt="HRIS Image 2"
          class="w-full md:h-[350px] lg:h-[200px] h-full rounded-2xl border-2 border-gray-300 object-cover shadow-lg"
        />
      </div>
    </div>

    <!-- Additional Paragraphs -->
    <div class="flex flex-col space-y-4 mt-2 md:mt-4 lg:mt-4 max-w-4xl">
      <p
        class="text-white text-justify text-[15px] sm:text-[16px] md:text-[17px] font-light leading-relaxed"
      >
        Overall, the system increased efficiency and accuracy within the HR
        Department, eliminating paper-based processes like travel orders,
        locator slips, leave applications, and recruitment documentation.
      </p>

      <p
        class="text-white text-justify text-[15px] sm:text-[16px] md:text-[17px] font-light leading-relaxed"
      >
        The recruitment module now enables applicants to upload documents
        directly into the system, which also serves as a database for future
        reference — replacing bulky physical submissions.
      </p>

      <p
        class="text-white text-justify text-[15px] sm:text-[16px] md:text-[17px] font-light leading-relaxed"
      >
        I appreciate the system’s mobile accessibility — even when I’m away from
        the office, I can approve and verify requests, offering convenience and
        flexibility in managing and tracking HR activities anytime, anywhere.
      </p>

      <p
        class="text-white text-justify text-[15px] sm:text-[16px] md:text-[17px] font-light leading-relaxed"
      >
        HRIS is user-friendly and acts in real time. Through the self-service
        portal, I can update personal data, generate PDS and SALN, and monitor
        leave balances, travel logs, and attendance easily.
      </p>

      <p
        class="text-white text-justify text-[15px] sm:text-[16px] md:text-[17px] font-light leading-relaxed"
      >
        Overall, DNSC’s HRIS promotes integrity and reliability in HR processes
        while supporting the PRIME-HRM initiative of the Civil Service
        Commission — enhancing productivity and satisfaction across the
        organization.
      </p>
    </div>

    <!-- Close Button -->
    <button
      @click="$emit('close')"
      class="mt-5 px-8 py-3 bg-white/20 backdrop-blur-md text-white font-semibold rounded-full border border-white/40 shadow-lg hover:bg-red-600 hover:text-white hover:border-red-600 transition duration-300 ease-in-out"
    >
      Close
    </button>
  </section>
</template>

<script>
export default {
  name: "EdjecFeedbackContent",
};
</script>

<style scoped>
/* ✅ Custom responsive spacing for the profile section */
.profile-section {
  margin-top: 94rem; /* default for mobile */
}

@media (min-width: 640px) {
  /* sm screens (small tablets, large phones) */
  .profile-section {
    margin-top: 8rem;
  }
}

@media (min-width: 768px) {
  /* md screens (tablets) */
  .profile-section {
    margin-top: 73rem;
  }
}

@media (min-width: 1024px) {
  /* lg screens (laptops/desktops) */
  .profile-section {
    margin-top: 2rem;
  }
}

@media (min-width: 1280px) {
  /* xl screens (large desktops) */
  .profile-section {
    margin-top: 15rem;
  }
}
/* Smooth scrollbar for overflow sections */
section::-webkit-scrollbar {
  width: 8px;
}
section::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.25);
  border-radius: 10px;
}
</style>
